/**
 * Evidence location context - where the user is when triggering the event.
 * - logged_out: /chat route (no auth, anonymous)
 * - in_session: /scribe/session route (within an active scribe session)
 * - out_of_session: /scribe/chat route (logged in but not in a session)
 */
export enum EvidenceLocation {
  LoggedOut = 'logged_out',
  InSession = 'in_session',
  InSessionCentral = 'in_session_central',
  OutOfSession = 'out_of_session',
}

/**
 * Properties for tracking when the evidence onboarding modal is viewed.
 * Event: evidence_onboarding_viewed
 */
export interface EvidenceOnboardingViewedEventProps {
  /** Whether the user has a specialty already set */
  has_existing_specialty: boolean;
  /** Whether the user has a jurisdiction already set */
  has_existing_jurisdiction: boolean;
}

/**
 * Properties for tracking when the user saves preferences in the evidence onboarding modal.
 * Event: evidence_onboarding_saved
 */
export interface EvidenceOnboardingSavedEventProps {
  /** The specialty ID that was saved */
  specialty_id?: string;
  /** The jurisdiction code that was saved (e.g., "AU-NSW") */
  jurisdiction?: string;
  /** Whether the specialty was changed from an existing value */
  specialty_changed: boolean;
  /** Whether the jurisdiction was changed from an existing value */
  jurisdiction_changed: boolean;
}
